import State from 'interfaces/state/State';

export const email$ = (state: State): string => state.help.email;
export const isLoading$ = (state: State): boolean => state.help.isLoading;
export const isError$ = (state: State): boolean => state.help.isError;
export const isEmailSuccesfullySend$ = (state: State): boolean => state.help.isEmailSuccesfullySend;
